export default __webpack_public_path__ + "static/media/scoreRating_no_pass_bg.4c91d0fa.png";